/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CategoryLocationSeoDataNested
 */
export interface CategoryLocationSeoDataNested {
  /**
   *
   * @type {string}
   * @memberof CategoryLocationSeoDataNested
   */
  locationSlug?: string | null
  /**
   *
   * @type {string}
   * @memberof CategoryLocationSeoDataNested
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof CategoryLocationSeoDataNested
   */
  titleTag?: string | null
  /**
   *
   * @type {string}
   * @memberof CategoryLocationSeoDataNested
   */
  descriptionTag?: string | null
  /**
   *
   * @type {string}
   * @memberof CategoryLocationSeoDataNested
   */
  description?: string | null
}

/**
 * Check if a given object implements the CategoryLocationSeoDataNested interface.
 */
export function instanceOfCategoryLocationSeoDataNested(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function CategoryLocationSeoDataNestedFromJSON(json: any): CategoryLocationSeoDataNested {
  return CategoryLocationSeoDataNestedFromJSONTyped(json, false)
}

export function CategoryLocationSeoDataNestedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CategoryLocationSeoDataNested {
  if (json === undefined || json === null) {
    return json
  }
  return {
    locationSlug: !exists(json, 'locationSlug') ? undefined : json['locationSlug'],
    header: !exists(json, 'header') ? undefined : json['header'],
    titleTag: !exists(json, 'titleTag') ? undefined : json['titleTag'],
    descriptionTag: !exists(json, 'descriptionTag') ? undefined : json['descriptionTag'],
    description: !exists(json, 'description') ? undefined : json['description'],
  }
}

export function CategoryLocationSeoDataNestedToJSON(
  value?: CategoryLocationSeoDataNested | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    locationSlug: value.locationSlug,
    header: value.header,
    titleTag: value.titleTag,
    descriptionTag: value.descriptionTag,
    description: value.description,
  }
}
